import React from 'react'

import colorTokens from '../tokens/colors.ts'

const n = colorTokens.global.neutral

export const CHART_EMPTY_VARIANTS = ['bar', 'stacked-bar', 'donut', 'table'] as const
export type ChartEmptyVariant = (typeof CHART_EMPTY_VARIANTS)[number]

export const BarChartIllustration = (): React.ReactElement => (
  <svg
    viewBox="0 0 384 244"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', maxWidth: 280, height: 'auto' }}
    aria-hidden="true"
  >
    <line x1="59" y1="0" x2="59" y2="243" stroke={n[100]} strokeWidth="1.2" />
    <line
      x1="59"
      y1="243"
      x2="384"
      y2="243"
      stroke={n[100]}
      strokeWidth="1.2"
    />
    <rect x="74" y="142" width="55" height="101" rx="2" fill={n[400]} />
    <rect x="144" y="68" width="55" height="175" rx="2" fill={n[300]} />
    <rect x="214" y="142" width="55" height="101" rx="2" fill={n[400]} />
    <rect x="284" y="68" width="55" height="175" rx="2" fill={n[300]} />
  </svg>
)

export const StackedBarChartIllustration = (): React.ReactElement => (
  <svg
    viewBox="0 0 384 244"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', maxWidth: 280, height: 'auto' }}
    aria-hidden="true"
  >
    <line x1="0" y1="243" x2="384" y2="243" stroke={n[100]} strokeWidth="1.2" />
    <rect x="24" y="28" width="50" height="90" rx="2" fill={n[300]} />
    <rect x="24" y="118" width="50" height="60" rx="2" fill={n[400]} />
    <rect x="24" y="178" width="50" height="65" rx="2" fill={n[200]} />
    <rect x="84" y="58" width="50" height="70" rx="2" fill={n[400]} />
    <rect x="84" y="128" width="50" height="55" rx="2" fill={n[300]} />
    <rect x="84" y="183" width="50" height="60" rx="2" fill={n[200]} />
    <rect x="144" y="18" width="50" height="100" rx="2" fill={n[200]} />
    <rect x="144" y="118" width="50" height="65" rx="2" fill={n[400]} />
    <rect x="144" y="183" width="50" height="60" rx="2" fill={n[300]} />
    <rect x="204" y="68" width="50" height="60" rx="2" fill={n[300]} />
    <rect x="204" y="128" width="50" height="55" rx="2" fill={n[400]} />
    <rect x="204" y="183" width="50" height="60" rx="2" fill={n[200]} />
    <rect x="264" y="98" width="50" height="50" rx="2" fill={n[400]} />
    <rect x="264" y="148" width="50" height="45" rx="2" fill={n[200]} />
    <rect x="264" y="193" width="50" height="50" rx="2" fill={n[300]} />
    <rect x="324" y="138" width="50" height="40" rx="2" fill={n[200]} />
    <rect x="324" y="178" width="50" height="35" rx="2" fill={n[300]} />
    <rect x="324" y="213" width="50" height="30" rx="2" fill={n[400]} />
  </svg>
)

export const DonutChartIllustration = (): React.ReactElement => (
  <svg
    viewBox="0 0 180 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', maxWidth: 160, height: 'auto' }}
    aria-hidden="true"
  >
    <circle
      cx="90"
      cy="90"
      r="70"
      stroke={n[300]}
      strokeWidth="28"
      strokeDasharray="220 220"
      strokeDashoffset="0"
      strokeLinecap="butt"
    />
    <circle
      cx="90"
      cy="90"
      r="70"
      stroke={n[200]}
      strokeWidth="28"
      strokeDasharray="110 330"
      strokeDashoffset="-224"
      strokeLinecap="butt"
    />
    <circle
      cx="90"
      cy="90"
      r="70"
      stroke={n[400]}
      strokeWidth="28"
      strokeDasharray="70 370"
      strokeDashoffset="-338"
      strokeLinecap="butt"
    />
    <circle
      cx="90"
      cy="90"
      r="70"
      stroke={n[100]}
      strokeWidth="28"
      strokeDasharray="36 404"
      strokeDashoffset="-412"
      strokeLinecap="butt"
    />
  </svg>
)

export const TableIllustration = (): React.ReactElement => (
  <svg
    viewBox="0 0 280 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', maxWidth: 240, height: 'auto' }}
    aria-hidden="true"
  >
    <rect x="0" y="0" width="280" height="24" rx="2" fill={n[300]} />
    <rect x="0" y="32" width="280" height="20" rx="2" fill={n[200]} />
    <rect x="0" y="60" width="280" height="20" rx="2" fill={n[200]} />
    <rect x="0" y="88" width="280" height="20" rx="2" fill={n[200]} />
    <rect x="0" y="116" width="280" height="20" rx="2" fill={n[200]} />
  </svg>
)

export const illustrationByVariant: Record<
  ChartEmptyVariant,
  () => React.ReactElement
> = {
  bar: BarChartIllustration,
  'stacked-bar': StackedBarChartIllustration,
  donut: DonutChartIllustration,
  table: TableIllustration
}
